module.exports = __webpack_public_path__ + "img/carshina21_23.8e7c5947.jpg";